import type { ReactNode } from "react";

/** A labelled value in a detail screen's side panel. */
export function DetailField({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div>
      <div className="mb-1 text-xs font-medium uppercase tracking-wide text-[var(--text-3)]">{label}</div>
      <div className="text-sm text-gray-800">{children}</div>
    </div>
  );
}

/** The side panel of a detail screen, holding DetailFields. */
export function DetailAside({ children }: { children: ReactNode }) {
  return <aside className="grid h-max grid-cols-[minmax(0,1fr)] gap-4 rounded-xl border border-[var(--border)] bg-[var(--bg)] p-4">{children}</aside>;
}
